module.exports = __webpack_public_path__ + "img/littl_girls6.18b57672.jpg";